import { createAsyncThunk } from '@reduxjs/toolkit'
import Cast from './cast-model'
import { delete_cast, load_casts, store_cast } from './cast-service'

export const LoadCastsAsync = createAsyncThunk<any, any>(
  'composer/load/cast',
  async (params: { uid: string }) => {
    return await load_casts(params)
  },
)

export const CreateCastAsync = createAsyncThunk<any, any>(
  'composer/create/cast',
  async (params: Cast) => {
    return await store_cast(params)
  },
)

export const DeleteCastAsync = createAsyncThunk<any, any>(
  'composer/delete/cast',
  async (params) => {
    return await delete_cast(params)
  },
)
